import {BackendFetch} from "@hantera/portal-app";
import parseJson from "../parse-json";

export interface ListQueryResult {
  items: []
  totalHits: number
}

export type LegacyListType = 'orders' | 'rmas';

export interface ListQuery {

}

export interface ListColumn {
  id: string
  sort?: 'asc' | 'desc'
  fixedDateRange?: {
    fromUtc: Date
    toUtc: Date
  }
  relativeDate?: number
  facetValues?: string[]
}

export default function (portalFetch: BackendFetch, serverUrl: string) {

  return {
    /**
     * 
     * @param result The object to add results to
     * @param listType 
     * @param query 
     * @param skip 
     */
    async query(result: ListQueryResult, listType: LegacyListType, columns: ListColumn[], from?: string) {

      const res = await portalFetch('/legacy-list/query', {
        method: 'POST',
        body: JSON.stringify({
          listType,
          from,
          columns,
        }),
      });

      if (res.ok) {
        const serverResult = parseJson(await res.text());

        result.totalHits = serverResult.totalHits;
        result.items.push(...serverResult.items as []);

        return serverResult.items.length > 0 ? serverResult.next : undefined;
      }
    },
    // /**
    //  * 
    //  * @param listType 
    //  * @param query 
    //  * @param skip 
    //  */
    // async export(listType: LegacyListType, columns: ListColumn[]) {
    //
    //   const res = await portalFetch('/legacy-list/export', {
    //     method: 'POST',
    //     body: JSON.stringify({
    //       listType,
    //       columns,
    //     }),
    //   });
    //
    //   if (res.ok) {
    //     var path = await res.text();
    //
    //     window.location.assign(serverUrl + path);
    //   }
    // },
  };
}